import React, { useEffect, useRef, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Flex, Input, Tag, theme, Tooltip } from "antd";

const tagInputStyle = {
  width: 64,
  height: 22,
  marginInlineEnd: 8,
  verticalAlign: "top",
};
const OriginsJSX = ({
  tags,
  setTags,
  validationFn = () => {},
  newText = "Default Add text",
  className = "",
  autoBlur = true,
}) => {
  const { token } = theme.useToken();
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [editInputIndex, setEditInputIndex] = useState(-1);
  const [editInputValue, setEditInputValue] = useState("");
  const inputRef = useRef(null);
  const editInputRef = useRef(null);
  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);
  useEffect(() => {
    editInputRef.current?.focus();
  }, [editInputValue]);
  const handleClose = removedTag => {
    const newTags = tags.filter(tag => tag !== removedTag);
    setTags(newTags);
  };
  const showInput = () => {
    setInputVisible(true);
    setEditInputIndex(-1);
    setEditInputValue("");
  };
  const handleInputChange = e => {
    setInputValue(e.target.value);
  };
  const handleInputConfirm = (blur = true) => {
    const isValid = validationFn(inputValue);
    if (isValid) {
      if (inputValue && !tags.includes(inputValue)) {
        setTags([...tags, inputValue]);
      }
      if (blur) setInputVisible(false);
      setInputValue("");
    }
  };
  const handleEditInputChange = e => {
    setEditInputValue(e.target.value);
  };
  const handleEditInputConfirm = (autoBlur = true) => {
    const newTags = [...tags];
    const isValid = validationFn(editInputValue);
    if (isValid) {
      newTags[editInputIndex] = editInputValue;
      setTags(newTags);
      if (autoBlur) {
        setEditInputIndex(-1);
        setEditInputValue("");
      }
    }
  };
  const tagPlusStyle = {
    height: 22,
    background: token.colorBgContainer,
    borderStyle: "dashed",
  };
  return (
    <Flex gap="4px 0" className={className}>
      {tags.map((tag, index) => {
        if (editInputIndex === index) {
          return (
            <Input
              ref={editInputRef}
              key={tag}
              size="small"
              className="w-max"
              style={tagInputStyle}
              value={editInputValue}
              onChange={handleEditInputChange}
              onBlur={e => {
                e.preventDefault();
                handleEditInputConfirm(autoBlur);
              }}
              onPressEnter={e => {
                e.preventDefault();
                handleEditInputConfirm();
              }}
            />
          );
        }
        const isLongTag = tag.length > 20;
        const tagElem = (
          <Tag
            key={tag}
            closable
            style={{
              userSelect: "none",
            }}
            onClose={() => handleClose(tag)}
          >
            <span
              onDoubleClick={e => {
                setEditInputIndex(index);
                setEditInputValue(tag);
                setInputVisible(false);
                e.preventDefault();
              }}
            >
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </span>
          </Tag>
        );
        return isLongTag ? (
          <Tooltip title={tag} key={tag}>
            {tagElem}
          </Tooltip>
        ) : (
          tagElem
        );
      })}
      {inputVisible ? (
        <Input
          ref={inputRef}
          type="text"
          size="small"
          className="w-max"
          style={tagInputStyle}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={e => {
            e.preventDefault();
            handleInputConfirm(autoBlur);
          }}
          onPressEnter={e => {
            e.preventDefault();
            handleInputConfirm();
          }}
        />
      ) : (
        <Tag style={tagPlusStyle} icon={<PlusOutlined />} onClick={showInput}>
          {newText}
        </Tag>
      )}
    </Flex>
  );
};
export default OriginsJSX;
